import { Pool } from "../Collections/Pool";
import { NodeList } from "../Collections/NodeList";
import { Timer } from "./Timer";
import { TimeLoop } from "./Loop";



export class TimeManager {
    /**
     * (RO) Pomer vuci pozadovane rychlosti hry (60 FPS). 1 = 100% rychlost, 2 = 50% rychlost, ...
     */
    deltaRatio: number;

    /**
     * (RO) Cas ve vterinach od posledniho snimku.
     */
    deltaS: number;

    /**
     * (RO) Cas v ms od posledniho snimku.
     */
    deltaMs: number;

    private _freeTimers: Pool<Timer>;
    private _actTimers: NodeList<Timer>;
    private _inactTimers: NodeList<Timer>;

    private _freeLoops: Pool<TimeLoop>;
    private _actLoops: NodeList<TimeLoop>;
    private _inactLoops: NodeList<TimeLoop>;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        // Casovace
        this._actTimers = new NodeList<Timer>();
        this._inactTimers = new NodeList<Timer>();
        this._freeTimers = new Pool<Timer>(undefined, 0, true, (): Timer => {
            return new Timer(this, this._freeTimers, this._actTimers, this._inactTimers);
        }, this);

        // Casove smycky
        this._actLoops = new NodeList<TimeLoop>();
        this._inactLoops = new NodeList<TimeLoop>();
        this._freeLoops = new Pool<TimeLoop>(undefined, 0, true, (): TimeLoop => {
            return new TimeLoop(this._freeLoops, this._actLoops, this._inactLoops);
        }, this);
    }

    //-------------------------------------------------------------------------
    /**
     * Odstrani vsechny casovace, prodlevy, ...
     */
    //-------------------------------------------------------------------------
    reset(): void {
        this._actTimers.forEach((timer: Timer) => { timer.release(); });
        this._inactTimers.forEach((timer: Timer) => { timer.release(); });

        this._actLoops.forEach((loop: TimeLoop) => { loop.release(); });
        this._inactLoops.forEach((loop: TimeLoop) => { loop.release(); });
    }

    //-------------------------------------------------------------------------
    /**
     * Vytvoreni casovace
     */
    //-------------------------------------------------------------------------
    createTimer(): Timer {
        return this._freeTimers.getItem()
            ._initialize();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    createLoop(): TimeLoop {
        return this._freeLoops.getItem();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(deltaS: number): void {
        this.deltaS = deltaS;
        this.deltaMs = deltaS * 1000;
        this.deltaRatio = this.deltaMs / (1000 / 60);

        this._actTimers.forEach((timer: Timer) => { timer._update(this.deltaMs); });
        this._actLoops.forEach((loop: TimeLoop) => { loop._update(this.deltaMs); });
    }
}